import { getSocialChannelTypeUid, SocialChannelType, SocialChannelTypeSchema } from '../models/SocialChannelType'
import { getFinder, getInserter } from 'src/util/src/zod'
import { Anchor, Discord, Facebook, GitHub, Instagram, LinkedIn, Medium, Reddit, Telegram, Twitter, YouTube } from './allSocialNetworks'

export const allSocialChannelTypes: SocialChannelType[] = []

export const addSocialChannelType = getInserter('SocialChannelType', SocialChannelTypeSchema, getSocialChannelTypeUid, allSocialChannelTypes)

export const findSocialChannelType = getFinder(getSocialChannelTypeUid, allSocialChannelTypes)

export const TelegramGroup = addSocialChannelType({
  name: 'Group',
  network: Telegram,
  // TODO: Some groups use "https://t.me/joinchat/{{slug}}" pattern
  followUrlPattern: 'https://t.me/{{slug}}',
})

export const TelegramChannel = addSocialChannelType({
  name: 'Channel',
  network: Telegram,
  followUrlPattern: 'https://t.me/{{slug}}',
})

export const TwitterProfile = addSocialChannelType({
  name: 'Profile',
  network: Twitter,
  followUrlPattern: 'https://twitter.com/{{slug}}',
})

export const YouTubeChannel = addSocialChannelType({
  name: 'Channel',
  network: YouTube,
  followUrlPattern: 'https://www.youtube.com/channel/{{slug}}',
})

export const DiscordServer = addSocialChannelType({
  name: 'Server',
  network: Discord,
  followUrlPattern: 'https://discord.gg/{{slug}}',
})

export const RedditSubreddit = addSocialChannelType({
  name: 'Subreddit',
  network: Reddit,
  followUrlPattern: 'https://www.reddit.com/r/{{slug}}',
})

export const MediumProfile = addSocialChannelType({
  name: 'Profile',
  network: Medium,
  followUrlPattern: 'https://{{slug}}.medium.com/',
})

export const MediumPublication = addSocialChannelType({
  name: 'Publication',
  network: Medium,
  followUrlPattern: 'https://medium.com/{{slug}}',
})

export const GitHubProfile = addSocialChannelType({
  name: 'Profile',
  network: GitHub,
  followUrlPattern: 'https://github.com/{{slug}}',
})

export const GitHubOrganization = addSocialChannelType({
  name: 'Organization',
  network: GitHub,
  followUrlPattern: 'https://github.com/{{slug}}',
})

export const AnchorPodcast = addSocialChannelType({
  name: 'Podcast',
  network: Anchor,
  followUrlPattern: 'https://anchor.fm/{{slug}}',
})

export const LinkedInCompany = addSocialChannelType({
  name: 'Company',
  network: LinkedIn,
  followUrlPattern: 'https://www.linkedin.com/company/{{slug}}',
})

export const InstagramProfile = addSocialChannelType({
  name: 'Profile',
  network: Instagram,
  followUrlPattern: 'https://www.instagram.com/{{slug}}/',
})

export const FacebookPage = addSocialChannelType({
  name: 'Page',
  network: Facebook,
  followUrlPattern: 'https://facebook.com/{{slug}}',
})
